import React from 'react';
import style from './style.module.scss';

const SportsLoader = () => {
  return (
    <div className={style.loadingWrapper}>
      <div className={style.loadingWrapper}>
        <div className={style.loading_container}>
          <div className={style.loading} />
          <div id={style.loading_text}>NAMED</div>
        </div>
      </div>
    </div>
  );
};

export default SportsLoader;
